import { Container, Box } from "@mui/material";
import OutsideTopNavigation from "@layout/navigation/OutsideTopNavigation";
import Footer from "@layout/footers/OutsideFooter";
import React, { Fragment } from "react";

const OutsidePageLayout = (props) => {
  const { children } = props;

  const pages = [
    {
      title: "Login",
      path: "/login",
    },
  ];
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: 0,
        gridTemplateRows: "auto",
        gridTemplateAreas: `"header header header header"
                            "main main main main"
                            "footer footer footer footer"`,
      }}
    >
      <Box sx={{ gridArea: "header" }}>
        <OutsideTopNavigation pages={pages} />
      </Box>
      <Box
        sx={{
          gridArea: "main",
          bgcolor: "white.main",
        }}
      >
        {children}
      </Box>
      <Box sx={{ gridArea: "footer", bgcolor: "background.main" }}>
        <Footer />
      </Box>
    </Box>
  );
};

export default OutsidePageLayout;
